/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Scope_GlobalInputs */

const en_us2_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open clubs`)
};

const pt_br2_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes abertos`)
};

const es_419_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes abiertos`)
};

const pt_pt2_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubes abertos`)
};

const fr_fr2_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs ouverts`)
};

const de_de2_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offene Clubs`)
};

const it_it2_clubs_scope_global = /** @type {(inputs: Clubs_Scope_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club aperti`)
};

/**
* | output |
* | --- |
* | "Open clubs" |
*
* @param {Clubs_Scope_GlobalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_scope_global = /** @type {((inputs?: Clubs_Scope_GlobalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Scope_GlobalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_scope_global(inputs)
	if (locale === "es-419") return es_419_clubs_scope_global(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_scope_global(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_scope_global(inputs)
	if (locale === "de-DE") return de_de2_clubs_scope_global(inputs)
	if (locale === "it-IT") return it_it2_clubs_scope_global(inputs)
	return en_us2_clubs_scope_global(inputs)
});
export { clubs_scope_global as "clubs.scope_global" }